import React, { FC } from 'react'
import { StyledButton, StyledButtonReset } from 'Pages/landings/common/components/Button/styled'
import { Callback } from 'Pages/landings/common/types'

interface ComponentProps {
	children: JSX.Element | string
	onClick?: Callback
	type?: 'black' | 'white' | 'reset'
	wide?: boolean
	className?: string
}

export const Button: FC<ComponentProps> = ({
	children,
	onClick,
	type = 'black',
	wide,
	className,
}) => {
	const ButtonWrapper = type === 'reset' ? StyledButtonReset : StyledButton
	const props = type === 'reset' ? {} : { colorType: type, wide }
	return (
		<ButtonWrapper {...props} onClick={onClick} className={className}>
			<div>{children}</div>
		</ButtonWrapper>
	)
}
